import React from 'react';
import { useIntl } from 'react-intl';
import Button from '@starbucks-web/pattern-library/lib/components/button';

import { usePdpContext } from 'ordering/app/components/product-details-page/pdp-provider';

import messages from './messages';

const ResetRecipeButton = ({ onResetRecipeRef }) => {
  const { formatMessage } = useIntl();
  const { clearSelectedOptions } = usePdpContext();

  const handleResetRecipe = () => {
    clearSelectedOptions();
    // if the selected options are cleared,
    // the ResetRecipeButton will no longer be rendered
    // so we move focus to an appropriate element.
    onResetRecipeRef?.current?.focus();
  };

  return (
    <Button onClick={handleResetRecipe}>
      {formatMessage(messages.resetRecipe)}
    </Button>
  );
};

export default ResetRecipeButton;
